module.exports = __webpack_public_path__ + "static/media/yelp.0653b58a.png";